<template>
  <v-app class="app-dashboard-equipe">
    <v-container fluid>
      <dashboard-filtros
        :equipe="select_equipe"
        :meta="select_meta"
        :candidatos="selects.candidatos.items"
        :metas="selects.metas.items"
        :disabled-equipe="selects.candidatos.ativado"
        @update:equipe="handleEquipeChange"
        @update:meta="handleMetaChange"
        @refresh="atualizarDados"
      />

      <kpi-cards
        :total-cadastro="cards.total_cadastro"
        :total-meta="cards.total_meta"
        :loading="loadingCards"
      />

      <top-assessores
        :assessores="assessores"
        :loading="loadingAssessores"
        :select-equipe="select_equipe"
        :select-meta="select_meta"
        @refresh="atualizarDados"
      />

      <distribuicao-zona
        :series="zoneSeries"
        :labels="zoneLabels"
        :pessoas-map="zonaPessoasMap"
        :aggregated="aggregatedZona"
        :aggregated-labels="aggregatedZonaLabels"
        :apuracao-map="zonaApuracaoMap"
        :total-apuracao="totalApuracao"
        :meta-filtrada="metaFiltrada"
        :loading="loadingCharts"
      />

      <performance-secao
        :series="sectionSeries"
        :labels="sectionLabels"
        :pessoas-map="secaoPessoasMap"
        :loading="loadingCharts"
      />
    </v-container>
  </v-app>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import DashboardAPI from "./../../api/dashboard";
import AclAPI from "./../../api/acl";
import DashboardFiltros from "./equipe/DashboardFiltros.vue";
import KpiCards from "./equipe/KpiCards.vue";
import TopAssessores from "./equipe/TopAssessores.vue";
import DistribuicaoZona from "./equipe/DistribuicaoZona.vue";
import PerformanceSecao from "./equipe/PerformanceSecao.vue";

Vue.component("apexchart", VueApexCharts);

export default {
  components: {
    DashboardFiltros,
    KpiCards,
    TopAssessores,
    DistribuicaoZona,
    PerformanceSecao,
  },
  data() {
    return {
      loading: false,
      loadingCards: false,
      loadingAssessores: false,
      loadingCharts: false,
      cards: {
        total_cadastro: 0,
        total_meta: 0,
        total_percentual: 0,
      },
      select_equipe: "null",
      select_meta: "null",
      selects: {
        candidatos: {
          ativado: false,
          items: [],
        },
        metas: {
          items: [],
        },
      },
      assessores: [],
      zoneSeries: [],
      zoneLabels: [],
      sectionSeries: [],
      sectionLabels: [],
      aggregatedZona: null,
      aggregatedZonaLabels: [],
      zonaPessoasMap: {},
      secaoPessoasMap: {},
      zonaApuracaoMap: {},
      totalApuracao: 0,
      chartHeights: {
        donut: 320,
        bar: 320,
      },
    };
  },
  computed: {
    metaProgress() {
      if (!this.cards.total_meta) return 0;
      const percent = (this.cards.total_cadastro / this.cards.total_meta) * 100;
      return Math.min(Math.max(Number(percent.toFixed(2)), 0), 200);
    },
    metaRemaining() {
      if (!this.cards.total_meta) return 0;
      return Math.max(this.cards.total_meta - this.cards.total_cadastro, 0);
    },
    metaFiltrada() {
      return Boolean(this.select_meta) && this.select_meta !== "null";
    },
  },
  watch: {},
  filters: {
    formatPercent(value) {
      const numeric = Number(value) || 0;
      return `${numeric.toFixed(1)}%`;
    },
  },
  created() {
    this.Helpers.verificarToken();
    this.buscaCandidatos();
    this.$nextTick(() => {
      this.setEquipeInicial();
    });
  },
  mounted() {
    this.updateChartHeights();
    window.addEventListener("resize", this.updateChartHeights);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateChartHeights);
  },
  methods: {
    formatNumber(value) {
      const number = Number(value) || 0;
      return number.toLocaleString("pt-BR");
    },
    formatPontuacao(value) {
      const number = Number(value) || 0;
      return number.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatDateTime(value) {
      if (!value) {
        return "-";
      }

      const [datePart, timePart] = String(value).split(" ");
      if (!datePart) {
        return value;
      }

      const [year, month, day] = datePart.split("-");
      if (!year || !month || !day) {
        return value;
      }

      const time = timePart ? timePart.slice(0, 5) : "";
      return `${day}/${month}/${year}${time ? " " + time : ""}`;
    },
    setEquipeInicial() {
      const equipe = localStorage.getItem("equipe");
      const perfil = localStorage.getItem("controle");
      const idUsuario = localStorage.getItem("id");

      if (perfil == 3) {
        const equipeCandidato =
          equipe && equipe !== "null"
            ? parseInt(equipe, 10)
            : parseInt(idUsuario, 10);
        this.select_equipe = equipeCandidato;
        this.selects.candidatos.ativado = true;
        this.handleEquipeChange();
        return;
      }

      if (equipe && equipe !== "null") {
        this.select_equipe = parseInt(equipe, 10);
        this.selects.candidatos.ativado = true;
        this.handleEquipeChange();
      } else {
        this.fetchOverviewData();
      }
    },
    buscaCandidatos() {
      const headers = this.Helpers.getHeaderRequisicao();
      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.candidatos.items = [];

          if (response.status === 200) {
            this.selects.candidatos.items = response.data.candidatos || [];

            this.selects.candidatos.items.push({
              idcandidato: "null",
              nome_completo: "TODAS",
              chapa: 0,
            });
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    async handleEquipeChange(novoValor) {
      if (novoValor !== undefined) {
        this.select_equipe = novoValor;
      }
      await this.carregarMetas(this.select_equipe);
      this.fetchOverviewData();
    },
    handleMetaChange(novoValor) {
      this.select_meta = novoValor;
      this.fetchOverviewData();
    },
    async carregarMetas(equipe) {
      if (!equipe || equipe === "null") {
        this.selects.metas.items = [{ idmeta: "null", descricao: "TODAS" }];
        this.select_meta = "null";
        return;
      }

      const headers = this.Helpers.getHeaderRequisicao();
      try {
        const params = {
          equipe,
          somente_cadastros: true,
        };
        const response = await AclAPI.getMetas(headers, params);
        const token = response.data.token;
        localStorage.setItem("token", token);

        this.selects.metas.items = response.data.metas || [];
        this.selects.metas.items.push({
          idmeta: "null",
          descricao: "TODAS",
        });
        this.select_meta = "null";
      } catch (error) {
        this.Helpers.logout();
      }
    },
    atualizarDados() {
      this.fetchOverviewData();
    },
    fetchOverviewData() {
      this.loading = true;
      Promise.all([
        this.buscarTotais(),
        this.buscarAssessores(),
        this.buscarPessoasAnalytics(),
      ])
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buscarTotais() {
      this.loadingCards = true;
      const headers = this.Helpers.getHeaderRequisicao();
      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta !== "null" ? this.select_meta : undefined,
      };

      return DashboardAPI.getTotais(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          const totais =
            (response.data &&
              response.data.totais &&
              response.data.totais[0]) ||
            {};
          this.cards.total_cadastro = Number(totais.total_cadastrado) || 0;
          this.cards.total_meta = Number(totais.total_geral_meta) || 0;
          this.cards.total_percentual = Number(totais.percentual) || 0;
        })
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => {
          this.loadingCards = false;
        });
    },
    buscarAssessores() {
      this.loadingAssessores = true;
      const headers = this.Helpers.getHeaderRequisicao();
      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta !== "null" ? this.select_meta : undefined,
      };

      return DashboardAPI.getAssessores(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.assessores = (response.data.assessores || []).map((assessor) => ({
            ...assessor,
            total_cadastrado: Number(assessor.total_cadastrado) || 0,
            percentual: Number(assessor.percentual) || 0,
            pontuacao_assessor: Number(assessor.pontuacao_assessor) || 0,
            pontuacao_meta: Number(assessor.pontuacao_meta) || 0,
          }));
        })
        .catch(() => {
          this.assessores = [];
          this.Helpers.logout();
        })
        .finally(() => {
          this.loadingAssessores = false;
        });
    },
    buscarPessoasAnalytics() {
      this.loadingCharts = true;
      if (!this.select_equipe || this.select_equipe === "null") {
        this.zoneSeries = [];
        this.zoneLabels = [];
        this.sectionSeries = [];
        this.sectionLabels = [];
        this.zonaPessoasMap = {};
        this.secaoPessoasMap = {};
        this.aggregatedZonaLabels = [];
        this.aggregatedZona = null;
        this.zonaApuracaoMap = {};
        this.totalApuracao = 0;
        this.loadingCharts = false;
        return Promise.resolve();
      }

      const headers = this.Helpers.getHeaderRequisicao();
      const params = { equipe: this.select_equipe };
      if (this.select_meta && this.select_meta !== "null") {
        params.meta = this.select_meta;
      }

      return Promise.all([
        AclAPI.getPessoasGeral(headers, params),
        AclAPI.getApuracaoPorZona(headers, { equipe: this.select_equipe }),
      ])
        .then(([pessoasResp, apuracaoResp]) => {
          const token = apuracaoResp.data.token || pessoasResp.data.token;
          if (token) {
            localStorage.setItem("token", token);
          }

          const pessoas = pessoasResp.data.pessoas || [];
          this.processarDistribuicoes(pessoas);

          const apuracaoRows = apuracaoResp.data.apuracao || [];
          const mapa = {};
          apuracaoRows.forEach((row) => {
            if (!row.zona && row.zona !== 0) return;
            const chave = `Zona ${row.zona}`;
            mapa[chave] = (mapa[chave] || 0) + Number(row.votos || 0);
          });
          this.zonaApuracaoMap = mapa;
          this.totalApuracao = Number(apuracaoResp.data.total_votos || 0);
        })
        .catch(() => {
          this.zoneSeries = [];
          this.zoneLabels = [];
          this.sectionSeries = [];
          this.sectionLabels = [];
          this.zonaPessoasMap = {};
          this.secaoPessoasMap = {};
          this.aggregatedZonaLabels = [];
          this.aggregatedZona = null;
          this.zonaApuracaoMap = {};
          this.totalApuracao = 0;
          this.Helpers.logout();
        })
        .finally(() => {
          this.loadingCharts = false;
        });
    },
    processarDistribuicoes(pessoas) {
      const zonaMapa = {};
      const zonaPessoasMap = {};
      const secaoMapa = {};
      const secaoPessoasMap = {};

      pessoas.forEach((pessoa) => {
        const zona = pessoa.zona ? `Zona ${pessoa.zona}` : "Não informada";
        const secao = pessoa.secao ? `Seção ${pessoa.secao}` : "Não informada";

        zonaMapa[zona] = (zonaMapa[zona] || 0) + 1;
        if (!zonaPessoasMap[zona]) {
          zonaPessoasMap[zona] = [];
        }
        zonaPessoasMap[zona].push(pessoa);

        if (!secaoPessoasMap[secao]) {
          secaoPessoasMap[secao] = [];
        }
        secaoPessoasMap[secao].push(pessoa);

        secaoMapa[secao] = (secaoMapa[secao] || 0) + 1;
      });

      const zonaEntries = Object.entries(zonaMapa).map(([nome, valor]) => ({
        nome,
        valor,
      }));

      zonaEntries.sort((a, b) => b.valor - a.valor);

      let zonasExibidas = zonaEntries;
      this.aggregatedZona = null;
      this.aggregatedZonaLabels = [];

      if (zonaEntries.length > 7) {
        const top = zonaEntries.slice(0, 6);
        const restante = zonaEntries.slice(6);
        const totalRestante = restante.reduce((acc, item) => acc + item.valor, 0);
        if (totalRestante > 0) {
          const aggregatedEntry = {
            nome: "Outras Zonas",
            valor: totalRestante,
          };
          zonasExibidas = [...top, aggregatedEntry];
          this.aggregatedZona = aggregatedEntry;
          this.aggregatedZonaLabels = restante.map((item) => item.nome);
        } else {
          zonasExibidas = top;
        }
      } else {
        this.aggregatedZona = null;
        this.aggregatedZonaLabels = [];
      }

      this.zoneLabels = zonasExibidas.map((item) => item.nome);
      this.zoneSeries = zonasExibidas.map((item) => item.valor);
      this.zonaPessoasMap = zonaPessoasMap;
      this.secaoPessoasMap = secaoPessoasMap;

      const secaoEntries = Object.entries(secaoMapa)
        .map(([nome, valor]) => ({
          nome,
          valor,
        }))
        .sort((a, b) => b.valor - a.valor);

      const LIMIT_CHART = 50;
      const secaoTop = secaoEntries.slice(0, LIMIT_CHART);

      this.sectionLabels = secaoTop.map((item) => {
        if (item.nome.startsWith("Seção")) return item.nome;
        if (item.nome === "Não informada") return item.nome;
        return `Seção ${item.nome}`;
      });
      this.sectionSeries = secaoTop.map((item) => item.valor);

    },
    calcularRankingAssessores(items) {
      if (!items || !items.length) {
        return [];
      }

      const total = items.length || 1;
      const mapa = {};

      items.forEach((item) => {
        const nome = item.assessor || "Nao informado";
        mapa[nome] = (mapa[nome] || 0) + 1;
      });

      return Object.entries(mapa)
        .map(([nome, quantidade]) => ({
          nome,
          total: quantidade,
          percentual: (quantidade / total) * 100,
        }))
        .sort((a, b) => b.total - a.total)
        .map((item, index) => ({
          ...item,
          posicao: index + 1,
        }));
    },
    updateChartHeights() {
      const width = window.innerWidth || document.documentElement.clientWidth;

      if (width < 600) {
        this.chartHeights.donut = 300;
        this.chartHeights.bar = 260;
      } else if (width < 960) {
        this.chartHeights.donut = 360;
        this.chartHeights.bar = 280;
      } else {
        this.chartHeights.donut = 420;
        this.chartHeights.bar = 320;
      }
    },
  },
};
</script>

<style scoped>
.app-dashboard-equipe {
  background-color: #f5f7fb;
  min-height: 100vh;
}

.info-card,
.meta-card,
.chart-card {
  border-radius: 16px;
  min-height: 140px;
}

.chart-block {
  min-height: 360px;
}

.chart-wrapper {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 100%;
}

.chart-wrapper--stretch {
  display: block;
  padding: 0 8px 24px;
}

.chart-wrapper--stretch ::v-deep .apexcharts-canvas {
  width: 100% !important;
}

.chart-summary {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px 12px;
}

.summary-rank {
  width: 36px;
  font-weight: 600;
  color: #1976d2;
}

.summary-label {
  font-weight: 500;
  color: #37474f;
}

.summary-value {
  text-align: right;
  font-weight: 500;
  color: #424242;
}

.summary-percent {
  text-align: right;
  color: #00897b;
  font-weight: 600;
}

.summary-others {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
  margin-top: 8px;
}

.summary-others .summary-label {
  flex: 1;
}

.summary-others .summary-value,
.summary-others .summary-percent {
  width: auto;
}

.summary-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

@media (max-width: 960px) {
  .chart-card {
    min-height: 320px;
  }
  .chart-block {
    min-height: 320px;
  }
  .chart-wrapper {
    min-height: 320px;
  }
  .chart-wrapper--stretch {
    padding: 0 4px 20px;
  }
  .chart-summary {
    padding: 12px 8px 20px;
  }
  .summary-rank,
  .summary-value,
  .summary-percent {
    font-size: 0.85rem;
  }
  .summary-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 600px) {
  .chart-card {
    min-height: 280px;
  }
  .chart-block {
    min-height: 280px;
  }
  .chart-wrapper {
    min-height: 280px;
  }
  .chart-wrapper--stretch {
    padding: 0 2px 16px;
  }
  .chart-summary {
    padding: 12px 4px 16px;
  }
  .summary-label {
    font-size: 0.85rem;
  }
  .summary-actions {
    width: 100%;
  }
}
</style>
